import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function collapsableSidebar(theme: Theme): ComponentStyle {
  return {
    componentName: 'collapsableSidebar',
    baseStyle: {
      backgroundColor: theme.colors.onSurface
    }
  };
}
